import moment from 'moment'
import { FC, ReactElement } from 'react'
import { ReactComponent as Menu } from '../../assets/icons/menu.svg'
import logo from '../../assets/logo-white.svg'
import { User } from '../../externals/api/login'
import { useAuth } from '../../hooks/auth'
import LoggedUser from '../loggedUser'
import { useSideNavigation } from '../sideNavigation/context'
import { Container, Inside } from './styles'

type LoggedNavigationProps = {
}

export const trialDate = (user?: User): number | undefined => {
  if (user && user.subscription && user.subscription.cancellationEffectiveDate) {
    const momentSubscription = moment(user.subscription.cancellationEffectiveDate)
    const momentToday = moment()

    const diff = momentSubscription.diff(momentToday, 'days') + 1

    if (diff > 0) {
      return diff
    } else {
      return 0
    }
  }
}

const LoggedNavigation: FC<LoggedNavigationProps> = (): ReactElement => {
  const { user } = useAuth()
  const { setVisibility } = useSideNavigation()
  const userTrialDate = trialDate(user)

  return (
    <Container>
      <Inside>
        <button
          type='button'
          className='menu'
          onClick={() => setVisibility(true)}
        >
          <Menu />
        </button>
        <a className='logo' href='/'>
          <img src={logo} alt='logo' />
        </a>
        <div className='near'>
          {!!userTrialDate && (
            <>
              <span>|</span>
              {userTrialDate} dias de acesso restante
            </>
          )}
        </div>
        <div className='logged_user'>
          <LoggedUser
            name={user?.name || ''}
            avatar={user?.avatar || undefined}
          />
        </div>
      </Inside>
    </Container>
  )
}

export default LoggedNavigation
